import React from 'react';
import { API_DOCUMENTATION } from 'redux/lib/constants/api-urls';
import MainComponent from './main-component';

const AdminApiDocumentation = (props) => {
    return (
        <MainComponent url={`${API_DOCUMENTATION.URL}`}/>
    );
};
export default AdminApiDocumentation;
